export enum CustomerAuthenticationWorkspaceCapabilityAccessOperation {
    create = "8e7b2441-f421-4f39-8aaa-f25d6456900b",
    read = "d7d25bea-454e-45e5-9946-c4f112a27b5a",
    update = "a9656178-73e6-4165-b203-5d47770b5a0e",
    delete = "710a97e4-58d4-4888-b545-557084321ab3",
}
